module.exports = __webpack_public_path__ + "media/images/errors/404-a0aef69a5e264c7dbe3656f69d098718.png";